if (!window.Promise) window.Promise = require('promise-polyfill');
if (!window.fetch) window.fetch = require('unfetch');

Object.assign = require('object-assign');
require('../app/scripts/utils/classlist');



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/daca-voices/config/polyfills.js
// module id = 1
// module chunks = 0